import { DescriptionOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';
import { getMenuLabel } from '../../global/auth/use-menu-labels/use-menu-labels';
import { isCommunicationsTenant } from '../../screens/program-manager/communications/communications-tenants';

const route = 'management';

export const getManagerRoutesMap = ({ userIdentityService, org }: GetRoutesConfig): RoutesMaps => {
  const { isActivityLeader, isProgramManager, isVmAdmin } = userIdentityService;
  // Default to true if org data is not available yet
  const packageConfig = org?.packageConfig;
  const menuLabels = org?.menuLabels;

  return {
    route,
    heading: 'Management',
    Icon: DescriptionOutlined,
    isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
    items: [
      {
        ...getMenuLabel('managementDashboard', menuLabels),
        id: 'management.dashboard',
        route: 'dashboard',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.insights : false
      },
      {
        ...getMenuLabel('managementActivityManagement', menuLabels),
        id: 'management.activity-management',
        route: 'activity-management',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        ...getMenuLabel('managementRosters', menuLabels),
        id: 'management.rosters',
        route: 'rosters',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        ...getMenuLabel('managementVolunteers', menuLabels),
        id: 'management.volunteers',
        route: 'volunteers',
        isAuthorized: isProgramManager || isVmAdmin,
      },
      {
        ...getMenuLabel('managementBulletins', menuLabels),
        id: 'management.bulletins',
        route: 'bulletins',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.bulletins : false
      },
      {
        label: 'Communications',
        route: 'communications',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: !isCommunicationsTenant(org?.tenantId),
      },
      {
        ...getMenuLabel('managementReportManagement', menuLabels),
        id: 'management.report-management',
        route: 'report-management',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        ...getMenuLabel('managementIncidentManagement', menuLabels),
        id: 'management.incident-management',
        route: 'incident-management',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.incidents : false
      },
      {
        label: 'Program Management',
        id: 'management.program-management',
        route: 'program-management',
        isAuthorized: isProgramManager,
      },
    ],
  };
};
